<template>
    <div class="subject-box"
         :class="{'school-center': curTheme}"
    >
        <div class="bg">
            <img v-if="isHasUrl" crossOrigin="anonymous" class="img" :src="url" alt="img" />
            <img v-else class="img default" crossOrigin="anonymous" :src="$images.material.default" alt="img" />
            <div class="edit-box">
                <div class="btns">
                    <p class="btn-box"
                       v-if="$store.state.permissions['class_mamage_delete']"
                       @click="opt('del', $attrs)"><span class="iconfont icon-shanchu1"></span></p>
                    <!-- <p
                        class="btn-box" @click="opt('copyConfig', $attrs)"><span class="iconfont icon-fuzhi"></span></p> -->
                    <p
                        v-if="$store.state.permissions['class_mamage_share']"
                        class="btn-box"
                        @click="opt('share', $attrs)"><span class="iconfont icon-fenxiang"></span></p>
                </div>
                <p v-if="auth.edit" class="edit" @click="opt('edit', $attrs)">
                    <span>编辑</span>
                </p>
                <p class="edit preview"
                   :class="{noEdit: !auth.edit}"
                   @click="opt('preview', $attrs)">
                    <span>预览</span>
                </p>
                <p
                   v-if="['我的课件'].includes(typeSelect) && auth.down"
                   class="edit preview"
                   :class="{noEdit: !auth.down}"
                   @click="opt('down', $attrs)">
                    <span>下载</span>
                </p>
            </div>
        </div>
        <div class="row-one">
            <div class="modify-box">
                <p class="name">
                    <span class="ico-status"
                          :class="{[package_status]: true}"
                    ></span>
                    <span class="title">{{name}}</span>
                </p>
                <p v-if="auth.edit" class="edit"
                   @click="opt('editName', $attrs)">
                    <span class="modify-name">修改</span>
                </p>
            </div>
            <div class="sub-box">
                <p class="time">{{title}}</p>
                <el-dropdown
                    v-if="isMyCourseType"
                    @command="opt($event, $attrs)">
                    <span class="more-box">
                      <i class="iconfont icon-gengduo1"></i>
                    </span>
                    <el-dropdown-menu class="drop-box" slot="dropdown">
                        <el-dropdown-item
                            v-if="isMyCourseType"
                            command="detail"
                        ><span class="btn">查看</span></el-dropdown-item>
                        <el-dropdown-item
                            v-if="isMyCourseType"
                            command="update"
                        ><span class="btn">更新</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="isMyCourseType"
                                command="order"
                        ><span class="btn">排序</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="isMyCourseType"
                                command="copy"
                        ><span class="btn">复制课件</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="$store.state.permissions['class_mamage_move'] && isMyCourseType"
                                command="move"
                        ><span class="btn">移动课件</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="$store.state.permissions['class_mamage_template'] && isMyCourseType"
                                command="template"
                        ><span class="btn">设为模版</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="isMyCourseType"
                                command="edit-info"
                        ><span class="btn">课件信息编辑</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="$store.state.permissions['class_mamage_delete']"
                                command="del"
                        ><span class="btn">删除课件</span></el-dropdown-item>
                        <el-dropdown-item
                                v-if="$store.state.permissions['class_mamage_course']"
                                command="course"
                        ><span class="btn">线下上课</span></el-dropdown-item>

                        <el-dropdown-item
                            v-if="isAdd"
                            command="practice-game"
                        ><span class="btn">游戏练习{{data.is_bind_exercise_game ? '修改' : '制作'}}</span></el-dropdown-item>
                        <el-dropdown-item
                            v-if="isAdd"
                            command="practice-custom"
                        ><span class="btn">自定义练习{{data.is_bind_exercise_customize ? '修改' : '制作'}}</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <!--<div class="row-two">-->
            <!--<p class="ico" @click="opt('copyConfig', $attrs)"><span class="el-icon-tickets"></span></p>-->
            <!--&lt;!&ndash;<p class="ico" @click="opt('upload')"><span class="el-icon-upload2"></span></p>&ndash;&gt;-->
            <!--<p v-if="auth.delete" class="ico" @click="opt('del', $attrs)"><span class="el-icon-delete"></span></p>-->
            <!--&lt;!&ndash;<p class="ico" @click="opt('copy')"><span class="el-icon-document-copy"></span></p>&ndash;&gt;-->
            <!--<p v-if="auth.edit" class="ico share" @click="opt('share', $attrs)"><span class="el-icon-share"></span><span class="share">分享</span></p>-->
        <!--</div>-->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: "subject-box",
        props: {
            url: String,
            name: String,
            title: String,
            subTitle: String,
            time: String,
            config: [Object, String],
            data: Object,
            auth: Object,
            typeSelect: String,
            package_status: String
        },
        computed: {
            // 校区 校区开启和个人同时为true 才允许新增和编辑课件
            isAdd () {
                let state = false
                try {
                    if (`${this.$store.getters.curUserInfo.clients_course_make_status}` === '1' &&
                        `${this.$store.getters.curUserInfo.is_course_make}` === '1') {
                        state = true
                    }
                } catch (e) {
                    console.log('获取失败==>', e)
                }
                return state
            },
            isMyCourseType(){
                return this.typeSelect === '我的课件'
            },
            ...mapGetters(['curTheme']),
            isHasUrl(){
                let state = false
                if(this.url && this.url!=='https://ucenter.yunkedun.com'){
                    state = true
                }
                return state
            }
        },
        methods: {
            opt(type, data){
                const datas = this.data
                this.$emit('onOperation', {type, data, datas})
            }
        }
    }
</script>

<style lang="scss" scoped>
.subject-box{
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    width: 268px;
    height: 224px;
    margin-left: 22px;

    .bg{
        display: flex;
        width: 100%;
        flex: 1;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;
        background-color: #F0F2F5;

        .img{
            width: 100%;
            //height: 125px;
            object-fit: cover;
            transform: scale(1.1);
            transition: transform .3s linear;

            &.default{
                //width: 50px;
                //object-fit: contain;
            }
        }

        &:hover {
            .img {
                transform: scale(1);
            }
            .edit-box {
                background-color: rgba(0,0,0,.5);

                .edit{
                    opacity: 1;
                    top: 0px;
                }

                .btns{
                    opacity: 1;
                }
            }
        }

        .edit-box {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            position: absolute;
            background-color: rgba(0,0,0,0);
            transition: all .3s linear;
            opacity: 1;

            .btns{
                display: flex;
                flex-direction: row;
                position: absolute;
                top: 0px;
                right: 0px;
                margin-top: 15px;
                opacity: 0;
                transition: all .8s linear;

                .btn-box{
                    margin-right: 17px;

                    .iconfont{
                        color: white;

                        &:hover{
                            color: #EFB600;
                            cursor: pointer;
                        }
                    }
                }
            }

            .edit {
                border: 1px solid white;
                color: white;
                text-align: center;
                cursor: pointer;
                transition: all .5s linear;
                opacity: 0;
                position: relative;
                top: 0px;
                margin-top: 20px;
                width: 68px;
                font-size: 14px;
                font-weight: 400;
                line-height: 34px;
                height:34px;
                border-radius: 17px;

                &:hover{
                    background: #EFB600;
                    border-color: #EFB600;
                }
            }
            .preview{
                margin-left: 10px;
                display: flex;
                justify-content: center;
                flex-shrink: 0;

                &.noEdit{
                    /*margin-left: 0px;*/
                }

                .icon-yulan{
                    position: relative;
                    top: -2px;
                }
            }
        }
    }
    .row-one, .row-two{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .row-one{
        flex-direction: column;
        align-items: flex-start;
        padding: 14px 16px;

        .sub-box{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .more-box{
                .iconfont{
                    font-size: 26px;
                    cursor: pointer;

                    &:hover{
                        color: #EFB600;
                    }
                }
            }
        }

        .modify-box {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 288px;
                font-size: 14px;
                font-weight: 400;
                color: #303133;
                display: flex;
                flex-direction: row;
                align-items: center;

                .ico-status{
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    margin-right: 5px;
                    background-color: #AA2AD4;
                    border-radius: 50%;

                    &.success{
                        background-color: #45CB90;
                    }

                    &.failure{
                        background-color: #F5222D;
                    }

                    &.run{
                        background-color: #EFB600;
                    }
                }
                .title{
                    width: 92%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .edit {
                /*width: 40px;*/
                cursor: pointer;
                margin-left: 4px;
                flex-wrap: nowrap;
                flex-shrink: 0;
                justify-content: flex-end;

                .modify-name {
                    font-size: 14px;
                    font-weight: 400;
                    color: #EFB600;
                    line-height: 24px;
                }
            }
        }

        .time {
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .row-two{
        padding: 6px 30px 10px;
        .ico{
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 16px;
            border:1px solid rgba(153,153,153,1);
            border-radius: 4px;
            padding: 3px 4px;
            cursor: pointer;
            transition: background .2s linear;
            margin: 0px 6px;

            &:hover,&.active{
                background-color: #e7622e;
                border-color: #e7622e;
            }
            &:active{
                opacity: .8;
            }

            .share{
                margin-left: 2px;
                font-size: 12px;
                width: 25px;
            }
        }
    }
}
</style>
